import { Box, Button, Flex, InputTypeTextReduced } from '@gmg/gmg-react-components';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { isLicenseSystemIdFormatValid } from '../LicenseManagement';

export interface AddExistingLicenseSystemToOrgModalProps {
    onClose?: () => void;
    onSubmit: (id: string) => void;
};

const AddExistingLicenseSystemToOrgModal: FunctionComponent<AddExistingLicenseSystemToOrgModalProps> = (props) => {
    const { t } = useTranslation();
    const [serialNumber, setSerialNumber] = useState('');

    const normalizeSerialNumber = (input: string): string => {
        const digits = input.replace(/\D/g, '');
        return digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    };

    return (
        <Flex mr="24px" ml="24px" flexDirection="column">

            <Box className="px12_400_normal">
                {t('AddExistingLicenseSystemToOrg.modal_desc', 'You can manually add an existing license system here without the Application Service. This can be done offline, and does not require an internet connection of the license system itself. Please provide the serial number to continue.')}
            </Box>

            <Flex>
                <StyledLabel
                    className="px10_400_weak"
                    htmlFor="serialNumber">
                    {t('RequestTemporaryLicensesModal.input_serialNumber_label', 'Serial number')}
                </StyledLabel>
            </Flex>
            <Flex height="36px" mb="40px">
                <InputTypeTextReduced
                    id="serialNumber"
                    value={serialNumber}
                    width={'100%'}
                    onChange={e => {setSerialNumber(normalizeSerialNumber(e.target.value))}}
                    placeholder='0.000.000.000'
                />
            </Flex>
            <Flex justifyContent="flex-end" gap="10px">
                <Button
                    variant="primary"
                    type="submit"
                    disabled={!isLicenseSystemIdFormatValid(serialNumber!)}
                    onClick={() => {
                        props.onSubmit(serialNumber!);
                        props.onClose?.();
                    }}
                >
                    {t('ButtonTitles.action_add_system_btn', 'Add system')}
                </Button>
                <Button
                    variant="secondary"
                    type="reset"
                    onClick={() => props.onClose?.()}
                >
                    {t('ButtonTitles.action_cancel_btn', 'Cancel')}
                </Button>
            </Flex>
        </Flex>
    );
};

const StyledLabel = styled.label`
    margin-top: 30px;
    box-sizing: border-box;
    height: 20px;
`;

export default AddExistingLicenseSystemToOrgModal;